export class ApplicationSettingsEntry{

    parameterKey = '';
    
    parameterValue = '';

    parameterType = '' ;
}